import CommonActionType from "../actiontype/common.actiontype"
import { ConsentInfoActionType } from "../actiontype/consent-info.actiontype"

const initialState = {
    consentFormFields: null,
    consentFormValues: {},
    consentType: null,
    consentId: '',
    consentErrorScreenMessage: ''
}

export const consentInfoReducer = (state = initialState, action) => {
    switch (action.type) {
        case ConsentInfoActionType.SET_CONSENT_FORM_FIELDS:
            return { ...state, consentFormFields: action.payload }
        case ConsentInfoActionType.UPDATE_CONSENT_FORM_VALUES:
            return { ...state, consentFormValues: action.payload }
        case ConsentInfoActionType.SET_CONSENT_TYPE:
            return { ...state, consentType: action.payload }
        case ConsentInfoActionType.SET_CONSENT_ID:
            return { ...state, consentId: action.payload }
        case ConsentInfoActionType.SET_CONSENT_ERROR_SCREEN_MESSAGE:
            return {...state, consentErrorScreenMessage: action.payload }
        case CommonActionType.RESET_STATE:
            return { ...initialState }
        default:
            return state
    }
}